import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RealPropertyAgentFeedbackComponent } from '@modules/real-property-agent-details/modules/agent-feedback/real-property-agent-feedback.component';
import { SharedModule } from '@shared/shared.module';

import { services } from './services';

@NgModule({
  declarations: [RealPropertyAgentFeedbackComponent],
  imports: [CommonModule, SharedModule],
  providers: [...services],
  exports: [RealPropertyAgentFeedbackComponent],
})
export class AgentFeedbackModule {}
